import { EMPTY, of } from 'rxjs';
// ---- external imports -----

import { levelSelectors } from '~/store';
import { TEMP_END_LEVEL } from '~/lib/constants';
// ---- internal imports ----

import { goToNewLevel, finalLevelCompleted } from '../actions';
// ---- parent imports ----


function goToNextLevel$(state) {
	const action = goToNextLevel(state);
	if (action) {
		return of(action);
	}

	return EMPTY;
}

function goToNextLevel(state) {
	const curLevel = levelSelectors.getLevelNumber(state);
	const endLevel = Math.min(TEMP_END_LEVEL, levelSelectors.getMaxLevelNum(state));
	if (curLevel === endLevel) {
		return finalLevelCompleted();
	}

	return goToNewLevel(curLevel + 1);
}


export { goToNextLevel };

export default goToNextLevel$;
